import { useModal } from '@ebay/nice-modal-react'

import Icon from '@/components/Icon'
import InfoModal from '@/components/Modals/ModalV2/InfoModal'
import { useArcadeRouting } from '@/features/arcade/hooks/routing'

const StartPlaying = () => {
  return (
    <>
      <div className="h5 text-arcadeGreen mb-3">Collect. Convert. Compete.</div>
      <p className="mb-3 text-gray-300">
        Your older Digital Pop! collections have become new again with Droppp
        Arcade. Convert them into <Icon name="arcade" className="inline" />{' '}
        Arcade Points from your Inventory and compete on a seasonal leaderboard
        where the top <Icon name="trophy" className="inline" />
        333 ranks will be rewarded with an exclusive Pop! limited to only
        333pcs.
      </p>

      <span className="body-xs text-gray-300">
        Converting your Digital Pop! into Arcade Points is irreversible, and
        once an item is converted, it will be destroyed. Arcade Points do not
        carry over from season to season and will be reset to zero at the start
        of a new season.
      </span>
    </>
  )
}

export const useStartPlaying = () => {
  const startPlayingModal = useModal(InfoModal)
  const { convertPoints, howToPlay } = useArcadeRouting()

  const handleConvertPointsClick = async () => {
    await convertPoints.goTo()
    await startPlayingModal.hide()
  }

  const handleHowItWorksClick = async () => {
    await howToPlay.goTo()
    await startPlayingModal.hide()
  }

  const startPlaying = () => {
    startPlayingModal
      .show({
        title: 'Introducing Droppp Arcade!',
        children: <StartPlaying />,
        primaryButton: {
          onClick: handleConvertPointsClick,
          theme: 'green-arcade',
          label: 'Convert Points'
        },
        secondaryButton: {
          label: 'How It Works',
          onClick: handleHowItWorksClick,
          theme: 'gray'
        },
        header: {
          image: {
            path: 'global/modals/',
            id: 'arcade-header',
            alt: 'header image',
            width: 480,
            height: 300
          }
        }
      })
      .then()
  }

  return { startPlaying }
}
